import {listTiposFinalidadeImovel, deleteTipoFinalidadeImovel} from '@/domain/cadastro/services'
import window from './window/window.js'

export default {
  pageTitle: 'Tipos de Finalidade de Imóvel',
  columns: [
    {
      name: 'Código',
      required: true,
      label: 'Código',
      align: 'left',
      field: 'nome',
      sortable: true,
      parser: function (props) {
        return props.codigo
      }
    },
    {
      name: 'nome',
      required: true,
      label: 'Nome',
      align: 'left',
      field: 'nome',
      sortable: true,
      parser: function (props) {
        return props.nome
      }
    },
    {
      name: 'descricao',
      required: true,
      label: 'Descrição',
      align: 'left',
      field: 'descricao',
      sortable: true,
      parser: function (props) {
        return props.descricao
      }
    },
    {
      name: 'status',
      required: true,
      label: 'Situação',
      align: 'left',
      field: 'status',
      sortable: true,
      parser: function (props) {
        return props.active ? 'Ativo' : 'Inativo'
      }
    },
    {
      name: 'options',
      required: true,
      label: '',
      field: 'options',
      sortable: false
    }
  ],
  resolve: listTiposFinalidadeImovel,
  methods: {
    // window: window
    abrir: function (id) {
      window.call(this, {id: id, table: this.table})
    },
    novo: function () {
      window.call(this, {})
    },
    excluir: deleteTipoFinalidadeImovel
  }
}
